import { useCallback, useEffect, useMemo, useState } from "react";
import {
  Box,
  Container,
  Heading,
  // HStack,
  // Stack,
  VStack,
  Breadcrumb,
  BreadcrumbItem,
  FormControl,
  FormHelperText,
  HStack,
  Text,
  useToast,
  useDisclosure,
  // List,
  // ListItem,
  // Text,
} from "@chakra-ui/react";

import { ChevronRightIcon } from "@chakra-ui/icons";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
// import Card from "components/Card/Card";
import Input from "components/Input/Input";
import Button from "components/Button/Button";
import Select from "components/Select/Select";
import SuccessModal from "components/Modals/Success";
import Preview from "components/Modals/swap/SwapPreview";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

import { useLocation, useParams } from "react-router-dom";

import constants from "config/constant";
import toCoinLocale from "util/toCoinLocale";
import toPrecision from "util/toPrecision";
import {
  // useGetUserCardDetailQuery,
  useWithdrawFromCardMutation,
} from "services/cardsApi";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import getError from "util/getError";
import { toQueryString } from "util/utils";
import SubmitPin from "components/Modals/SubmitPin";
import useCardDetails from "hooks/useCardDetails";

import ls from "util/secureStorage";
import constant from "config/constant";

// import { useState } from "react";

const CardWithdrawal = (props) => {
  const currentPage = "Card";

  const { id } = useParams();
  const history = useHistory();
  const toast = useToast();
  const location = useLocation();

  console.log({ location });

  const searchParams = useMemo(
    () => new URLSearchParams(location?.search),
    [location]
  );

  const {
    isOpen: isPreviewOpen,
    onClose: onPreviewClose,
    onOpen: onPreviewOpen,
  } = useDisclosure();

  const { isOpen, onClose, onOpen } = useDisclosure();

  const [state, _set] = useState();
  const set = useCallback(
    (newState) => _set((state) => ({ ...state, ...newState })),
    []
  );

  const tempPin = useMemo(
    () => state?.pin ?? ls.get(constant.TEMP_PIN),
    [state?.pin]
  );
  const resetPin = () => set({ ...state, pin: null });

  const queries = useMemo(
    () => toQueryString({ p: searchParams.get("provider") }),
    [searchParams]
  );

  const {
    card: details,
    isFetching,
    isPinOpen,
    onPinClose,
    isCardError,
  } = useCardDetails(
    id,
    tempPin,
    { queries },
    resetPin,
    !!location?.state?.card
  );

  const card = useMemo(
    () => location?.state?.card ?? details,
    [location?.state?.card, details]
  );

  // const {
  //   data,
  //   isFetching,
  //   isError: isCardError,
  // } = useGetUserCardDetailQuery({ id, queries });
  // const card = useMemo(() => data?.data, [data]);

  const [
    _withdraw,
    { data: withdrawData, isLoading, isSuccess, isError, error },
  ] = useWithdrawFromCardMutation();

  const isInsufficientBalance = useMemo(
    () => +state?.amount > card?.balance,
    [state?.amount, card?.balance]
  );

  const isDisabled = useMemo(
    () =>
      !(state?.amount && state?.coin) ||
      isInsufficientBalance ||
      isFetching ||
      isLoading ||
      !card,
    [state, isInsufficientBalance, isFetching, isLoading, card]
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    onPreviewOpen();
  };

  const handleSuccessModalClose = () => {
    onClose();
    history.replace(
      `/dashboard/cards/${id}?provider=${searchParams.get("provider")}`,
      { card }
    );
  };

  const withdrawToWallet = () => {
    onPreviewClose();
    const reqData = {
      id,
      ...state,
      amount: +state?.amount,
      provider: searchParams.get("provider"),
    };

    // console.log("REQ DATA", reqData);
    _withdraw(reqData);
  };

  useEffect(() => {
    if (isSuccess && withdrawData) {
      onOpen();
    }

    if (!card && !isFetching && isCardError) {
      toast({
        position: "bottom-right",
        title: "Error",
        description: "Unable to retrieve card info",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }

    if (isError && error) {
      toast({
        position: "bottom-right",
        title: "Error",
        description: getError(error?.data?.error),
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  }, [
    isSuccess,
    error,
    withdrawData,
    isError,
    toast,
    history,
    onOpen,
    card,
    isFetching,
    isCardError,
  ]);

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="cards">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container maxW="container.xl">
            <Box px={["24px", "0", "0"]}>
              <Heading fontSize="3xl">Cards</Heading>

              <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/cards">Cards</BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem>
                  <BreadcrumbLink to={`/dashboard/cards/${id}`}>
                    My Card
                  </BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage href="#">
                    Withdraw
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Box>

            <Box
              bg="white"
              border="1px solid #8688942f"
              // minH="681px"
              w="calc(100% - 25vw)"
              //   w="fit-content"
              mt="32px"
              borderRadius="8px"
              p="48px 28px"
            >
              <VStack as="form" maxW="sm" m="0 auto" onSubmit={handleSubmit}>
                <FormControl>
                  <Input
                    label="Amount"
                    startAdornment={"$"}
                    value={state?.amount ?? ""}
                    onChange={(e) => set({ amount: e.target.value })}
                  />
                  {isInsufficientBalance && (
                    <FormHelperText color="red.400">
                      Insufficient funds
                    </FormHelperText>
                  )}
                </FormControl>
                <FormControl mt="20px !important">
                  <Select
                    label="Wallet"
                    placeholder="Select Wallet"
                    value={state?.coin ?? ""}
                    onChange={(e) => set({ coin: e.target.value })}
                  >
                    {constants.stableCoins.map((coin) => (
                      <option key={`stable-${coin}`} value={coin}>
                        {toCoinLocale(coin)}
                      </option>
                    ))}
                  </Select>

                  <FormHelperText fontSize="sm">
                    <HStack>
                      <Text>Available balance:</Text>
                      <Text color="var(--primary)">
                        {toPrecision(
                          card?.balance ?? 0,
                          card?.currency ?? "usd"
                        )}
                      </Text>
                    </HStack>
                  </FormHelperText>
                </FormControl>

                <Button
                  isLoading={isLoading}
                  disabled={isDisabled}
                  w="100%"
                  minH="64px"
                  mt="72px !important"
                  type="submit"
                  // onClick={handleSubmit}
                >
                  Withdraw
                </Button>
              </VStack>
            </Box>
          </Container>
        </Box>
      </Box>

      <Preview
        title="Summary"
        isOpen={isPreviewOpen}
        onClose={onPreviewClose}
        onConfirm={withdrawToWallet}
        buttonText={["Close", "Withdraw"]}
        data={{
          Wallet: toCoinLocale(state?.coin),
          Amount: toPrecision(state?.amount, state?.coin),
        }}
      />

      <SubmitPin
        isOpen={isPinOpen}
        onClose={onPinClose}
        // onPin={(pin) => handleState({ pin })}
        onSubmit={(pin) => set({ pin })}
        closeOnSubmit
        closable={false}
      />

      <SuccessModal
        isOpen={isOpen}
        onClose={handleSuccessModalClose}
        title={`Success`}
        message="Your withdrawal will be processed and your wallet will be funded
                  soon."
      />
    </Box>
  );
};

export default CardWithdrawal;
